import commonUtils from '@/js/workspace/common_util.js';

export default {
    sizeUtil(size) {
        var quantity;
        var measureUnit;
        if (size < 0) {
            quantity = 0;
            measureUnit = "B";
        } else if (size < (2 << 9)) {
            quantity = size;
            measureUnit = "B";
        } else if (size < (2 << 19)) {
            quantity = size / (2 << 9);
            measureUnit = "KB";
        } else if (size < (2 << 29)) {
            quantity = size / (2 << 19);
            measureUnit = "MB";
        } else {
            quantity = size / (2 << 29);
            if (quantity < (2 << 9)) {
                measureUnit = "GB";
            } else {
                quantity = quantity / (2 << 9);
                measureUnit = "TB";
            }
        }
        quantity = Math.floor(quantity * 100) / 100
        return quantity + measureUnit;
    },
    findFileTypeArray(data, id, nextArray) {
        let arr = Array.from(nextArray)
        for (let i = 0, len = data.length; i < len; i++) {
            if (data[i].appName) {
                arr.push(data[i].appName);
            } else if (data[i].dir) {
                arr.push('folder');
            }
            if (data[i].id === id) {
                return arr;
            }
            let children = data[i].children;
            if (children && children.length) {
                let result = this.findFileTypeArray(children, id, arr)
                if (result) return result
            }

        }
        return false;
    },
    findFilePathArray(data, node, indexArray) {
        let arr = Array.from(indexArray)
        for (let i = 0, len = data.length; i < len; i++) {
            arr.push(data[i].name);
            let driveId;
            let nodeDriveId;
            if (data[i].appName) {
                driveId = data[i].id;
            } else {
                driveId = data[i].driveId;
            }
            if (node.appName) {
                nodeDriveId = node.id;
            } else {
                nodeDriveId = node.driveId;
            }
            if (data[i].id === node.id && driveId == nodeDriveId) {
                return arr;
            }
            let children = data[i].children;
            if (children && children.length) {
                let result = this.findFilePathArray(children, node, arr)
                if (result) return result
            }
            arr.pop();
        }
        return false;
    },
    createTransferFromItems(sourceDrives) {
        return createMulitItems(sourceDrives);
    },
    createTransferToItems(toDrives) {
        return createSingleItems(toDrives);
    },
    createSyncFromItems(syncFromDrives) {
        return createSingleItems(syncFromDrives);
    },
    createSyncToItems(syncToDrives) {
        return createSyncMulitItems(syncToDrives);
    },
    checkCatalog(sourceCatalogArr, node) {
        let nKey;
        if (node.driveId) {
            nKey = node.driveId + node.id + node.cloudCatalog;
        } else if (node.rootId) {
            nKey = node.id + node.rootId + node.name;
        }
        if (sourceCatalogArr.includes(nKey)) {
            flag = false;
        } else {
            if (node.pnode && node.pnode.data) {
                node = node.pnode.data;
                this.checkCatalog(sourceCatalogArr, node);
            } else if (node.pnode && !node.pnode.data) {
                node = node.pnode;
                this.checkCatalog(sourceCatalogArr, node);
            } else {
                flag = true;
            }
        }
        return flag;
    },
    businessTransfer(ud, n,ftItems, options, schedules) {
        this.ud = ud;
       // this.type = type;
        this.n = n;
        this.ftItems = ftItems;
        if (options) {
            this.options = options;
        }
        if (schedules) {
            this.schedules = schedules;
        }
    },
    addTaskData(ud, type, n, fromItems, toItems, options, schedules){
        this.ud = ud;
        this.type = type;
        this.n = n;
        this.fromItems = fromItems;
        this.toItems = toItems;
        if (options) {
            this.options = options;
            this.options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        }
        if (schedules) {
            this.schedules = schedules;
        }
    },
	addTaskDataTest(id,ud, type) {
	    this.id = id;
		this.ud = ud;
	    this.type = type;
	},
    updateGdTaskData(gd, ud, type, n, options, schedules) {
        this.gd = gd;
        this.ud = ud;
        this.type = type;
        this.n = n;
        if (options) {
            this.options = options;
        }
        if (schedules) {
            this.schedules = schedules;
        }
    },
    updateIdTaskData(id, ud, type, n, options, schedules) {
        this.id = id;
        this.ud = ud;
        this.type = type;
        this.n = n;
        if (options) {
            this.options = options;
        }
        if (schedules) {
            this.schedules = schedules;
        }
    },
    DirItem(driveType, driveId, pid, fileId, filename, dir, nodes) {
        this.driveType = driveType;
        this.driveId = driveId;
        this.pid = pid;
        this.fileId = fileId;
        this.filename = filename;
        this.isDir = dir;
        this.nodes = nodes;
    },
    FileItem(driveType, driveId, pid, fileId, filename, dir, filesize, nodes) {
        this.driveType = driveType;
        this.driveId = driveId;
        this.pid = pid;
        this.fileId = fileId;
        this.filename = filename;
        this.isDir = dir;
        this.filesize = filesize;
        this.nodes = nodes;
    },




}
var fromNodes = [];
var toNodes = [];
let flag;

function DirItem(driveType, driveId, pid, fileId, filename, dir, nodes) {
    this.driveType = driveType;
    this.driveId = driveId;
    this.pid = pid;
    this.fileId = fileId;
    this.filename = filename;
    this.isDir = dir;
    this.nodes = nodes;
}

function FileItem(driveType, driveId, pid, fileId, filename, dir, filesize, nodes) {
    this.driveType = driveType;
    this.driveId = driveId;
    this.pid = pid;
    this.fileId = fileId;
    this.filename = filename;
    this.isDir = dir;
    this.filesize = filesize;
    this.nodes = nodes;
}

//同步源任务nodes  传输目标nodes
function createSingleItems(toDrives) {
    toNodes = [];
    var toItems = [];
    let fileId;
    let driveId;
    let pid;
    //暂时使用
    if(!toDrives) {
        toDrives = {
            driveType: "",
            driveId: "",
            rootId: "",
            id: "",
            pid: "",
            name: "",
        }
    }
    if (toDrives.appName) {
        fileId = toDrives.rootId;
        driveId = toDrives.id;
        pid = toDrives.rootId;

    } else {
        fileId = toDrives.id;
        driveId = toDrives.driveId;
        pid = toDrives.pid;
    }
    var nodes = setSingleNodes(toDrives);
    var item = new DirItem(toDrives.driveType, driveId, pid, fileId, toDrives.name, true, nodes);
    //添加文件类型
    if(toDrives.docType){
        item.docType = toDrives.docType;
    }
    toItems.push(item);
    return toItems;
}

function createMulitItems(sourceDrives) {
    var fromItems = new Array();
    let fileId;
    let driveId;
    let pid;
    let dir;
    let filesize;
    var item;
    var nodes;
    let shareUrl;//分享传输用 分享链接
    let way;//分享传输用 分享传输标识
    let sharePath;//分享传输用 分享文件夹下级路径
    let wd;//分享任务id
    let permissionId;//子账号权限id
    let cloudType;
    for (let i = 0; i < sourceDrives.length; i++) {
        fromNodes = [];
        if (sourceDrives[i].appName) {
            fileId = sourceDrives[i].rootId;
            driveId = sourceDrives[i].id;
            pid = sourceDrives[i].rootId;
            dir = true;
            nodes = setFromNodes(sourceDrives[i]);
            item = new DirItem(sourceDrives[i].driveType, driveId, pid, fileId, sourceDrives[i].name, dir, nodes);
            //分享传输用
            item.cloudType = sourceDrives[i].categoryInfo.id;
        } else {
            fileId = sourceDrives[i].id;
            driveId = sourceDrives[i].driveId;
            pid = sourceDrives[i].pid;
            nodes = setFromNodes(sourceDrives[i]);
            if (sourceDrives[i].dir) {
                dir = true;
                item = new DirItem(sourceDrives[i].driveType, driveId, pid, fileId, sourceDrives[i].name, dir, nodes);
            } else {
                dir = false;
                if(sourceDrives[i].size){
                filesize = sourceDrives[i].size;
                }else{
                filesize=0;
                }
                item = new FileItem(sourceDrives[i].driveType, driveId, pid, fileId, sourceDrives[i].name, dir, filesize, nodes);
            }
            //分享传输时使用
            if(sourceDrives[i].shareUrl){
                shareUrl = sourceDrives[i].shareUrl;
                item.shareUrl = shareUrl;
            }
            if(sourceDrives[i].way){
                way = sourceDrives[i].way;
                item.way = way;
            }
            if(sourceDrives[i].permissionId){
                //子账号添加permissionId
                permissionId = sourceDrives[i].permissionId;
                item.permissionId = permissionId;
                nodes[0].fileId = nodes[0].fileId.substring(32);//目标id
                nodes[nodes.length-1].permissionId = permissionId;
                //子账号添加driverId
                nodes.forEach(n => {
                    n.tokenId = driveId;
                });
            }
            if(sourceDrives[i].sharePath){
                sharePath = sourceDrives[i].sharePath;
                item.sharePath = sharePath;
                //在分享任务时，记录cryptId，用于标记sharePath
                if(sharePath.length>0){
                    //pnode存在于sharePath时，增加cryptId
                    item.nodes.forEach(e => {
                        let index = sharePath.find(n=>n.fileId==e.fileId);
                        if(index){
                            e.cryptId = index.cryptId;
                        }
                    });
                    item.nodes[item.nodes.length-1].shareId = sharePath[sharePath.length-1].fileId;
                }
            }
            //分享传输时使用
            if(sourceDrives[i].cloudType){
                item.cloudType = sourceDrives[i].cloudType;
            }
        }
        //部分云盘需要docType
        if(sourceDrives[i].docType){
            item.docType = sourceDrives[i].docType;
        }
        //部分云盘需要路由
        if(sourceDrives[i].webUrl){
            item.webUrl = sourceDrives[i].webUrl;
        }
        fromItems.push(item);
    }
    return fromItems;
}

function createSyncMulitItems(sourceDrives) {
    var fromItems = [];
    let fileId;
    let driveId;
    let pid;
    let dir;
    let filesize;
    var item;
    var nodes;
    for (let i = 0; i < sourceDrives.length; i++) {
        toNodes = [];
        if (sourceDrives[i].appName) {
            fileId = sourceDrives[i].rootId;
            driveId = sourceDrives[i].id;
            pid = sourceDrives[i].rootId;
            dir = true;
            nodes = setSingleNodes(sourceDrives[i]);
            item = new DirItem(sourceDrives[i].driveType, driveId, pid, fileId, sourceDrives[i].name, dir, nodes);
        } else {
            fileId = sourceDrives[i].id;
            driveId = sourceDrives[i].driveId;
            pid = sourceDrives[i].pid;
            nodes = setSingleNodes(sourceDrives[i]);
            if (sourceDrives[i].dir) {
                dir = true;
                item = new DirItem(sourceDrives[i].driveType, driveId, pid, fileId, sourceDrives[i].name, dir, nodes);
            } else {
                dir = false;
                if(sourceDrives[i].size){
                filesize = sourceDrives[i].size;
                }else{
                filesize=0;   
                }
                item = new FileItem(sourceDrives[i].driveType, driveId, pid, fileId, sourceDrives[i].name, dir, filesize, nodes);
            }
        }
        //添加文件类型
        if(sourceDrives[i].docType){
            item.docType = sourceDrives[i].docType;
        }
        fromItems.push(item);
    }
    return fromItems;
}

function setFromNodes(nodeData) {
    let nodeItem;
    if (nodeData.appName) {
        nodeItem = {
            fileId: nodeData.rootId,
            filename: nodeData.name
        }
    } else {
        nodeItem = {
            fileId: nodeData.id,
            filename: nodeData.name
        }
    }
    if(nodeData.docType){
        nodeItem.docType = nodeData.docType;
    }
    if(nodeData.queryParameter){
        nodeItem.queryParameter = nodeData.queryParameter;
    }
    fromNodes.push(nodeItem);
    if (nodeData.pnode) {
        if (nodeData.pnode.data) {
            setFromNodes(nodeData.pnode.data);
        } else {
            setFromNodes(nodeData.pnode);
        }
    }
    return fromNodes;
}

function setSingleNodes(nodeData) {
    let nodeItem;
    if (nodeData.appName) {
        nodeItem = {
            fileId: nodeData.rootId,
            filename: nodeData.name
        }
    } else {
        nodeItem = {
            fileId: nodeData.id,
            filename: nodeData.name
        }
    }
    toNodes.push(nodeItem);
    if (nodeData.pnode && nodeData.pnode.data) {
        setSingleNodes(nodeData.pnode.data);
    } else if (nodeData.pnode) {
        setSingleNodes(nodeData.pnode);
    }
    return toNodes;
}


// WEBPACK FOOTER //
// ./src/js/workspace/task_transfer_util.js